"use client"

import { createIcon } from "@chakra-ui/react"

export const CategoryIcon = createIcon({
  defaultProps: {},
  displayName: "CategoryIcon",
  path: (
    <>
      <path
        d="M10 3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM9 9H5V5h4v4zm11 4h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm-1 6h-4v-4h4v4zM17 3c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zM7 13c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z"
        fill="currentColor"
      />
    </>
  ),
  viewBox: "0 0 24 24",
})

export const LaptopIcon = createIcon({
  defaultProps: {
    fill: "currentColor",
  },
  displayName: "LaptopIcon",
  path: (
    <>
      <path d="M232,170H222V72a22,22,0,0,0-22-22H56A22,22,0,0,0,34,72v98H24a6,6,0,0,0-6,6v16a22,22,0,0,0,22,22H216a22,22,0,0,0,22-22V176A6,6,0,0,0,232,170ZM46,72A10,10,0,0,1,56,62H200a10,10,0,0,1,10,10v98H46ZM226,192a10,10,0,0,1-10,10H40a10,10,0,0,1-10-10V182H226ZM150,88a6,6,0,0,1-6,6H112a6,6,0,0,1,0-12h32A6,6,0,0,1,150,88Z" />
    </>
  ),
  viewBox: "0 0 256 256",
})

export const MobileDeviceIcon = createIcon({
  defaultProps: {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
  },
  displayName: "MobileDeviceIcon",
  path: (
    <>
      <path d="M6 5a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-14z" />
      <path d="M11 4h2" />
      <path d="M12 17v.01" />
    </>
  ),
  viewBox: "0 0 24 24",
})

export const MonitorIcon = createIcon({
  defaultProps: {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
  },
  displayName: "MonitorIcon",
  path: (
    <>
      <rect height="14" rx="2" width="20" x="2" y="3" />
      <line x1="8" x2="16" y1="21" y2="21" />
      <line x1="12" x2="12" y1="17" y2="21" />
    </>
  ),
  viewBox: "0 0 24 24",
})

export const TabletIcon = createIcon({
  defaultProps: {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
  },
  displayName: "TabletIcon",
  path: (
    <>
      <rect height="20" rx="2" ry="2" width="16" x="4" y="2" />
      <line x1="12" x2="12.01" y1="18" y2="18" />
    </>
  ),
  viewBox: "0 0 24 24",
})
